import type { ComponentInterface } from '@stencil/core';
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'jackery-tab-content',
  styleUrl: 'jackery-tab-content.css',
  shadow: true,
})
export class JackeryTabContent implements ComponentInterface {
  /**
   * tab 显示名称
   */
  @Prop() label: string = '';

  /**
   * tab 匹配名称(和 activekey 匹配)
   */
  @Prop({reflect: true}) name = "";

  /**
   * tab 禁用状态
   */
  @Prop() disabled: boolean = false;

  /**
   * 当前是否选中
   */
   @Prop({mutable: true}) active: boolean = false;

  render() {
    return (
      <Host
        class={{
          "active": this.active
        }}
      >
        <slot></slot>
      </Host>
    );
  }
}
